export const SHADES_BLUE = [
	{ bgcolor: "var(--blue-600)", color: "var(--color-white)" },
	{ bgcolor: "var(--blue-500)", color: "var(--color-white)" },
	{ bgcolor: "var(--blue-400)", color: "var(--color-black)" },
	{ bgcolor: "var(--blue-300)", color: "var(--color-black)" },
	{ bgcolor: "var(--blue-200)", color: "var(--color-black)" },
	{ bgcolor: "var(--blue-100)", color: "var(--color-black)" },
	{ bgcolor: "var(--blue-50)", color: "var(--color-black)" },
];

export const SHADES_GREY = [
	{ bgcolor: "var(--grey-600)", color: "var(--color-black)" },
	{ bgcolor: "var(--grey-500)", color: "var(--color-black)" },
	{ bgcolor: "var(--grey-400)", color: "var(--color-black)" },
	{ bgcolor: "var(--grey-300)", color: "var(--color-black)" },
	{ bgcolor: "var(--grey-200)", color: "var(--color-black)" },
	{ bgcolor: "var(--grey-100)", color: "var(--color-black)" },
	{ bgcolor: "var(--grey-50)", color: "var(--color-black)" },
];
